module.exports = __webpack_public_path__ + "img/add.3de8b475.svg";